import { Node, mergeAttributes } from '@tiptap/core';

export const ContractFieldNode = Node.create({
    name: 'contractField',
    group: 'inline',
    inline: true,
    atom: true,
    selectable: true,
    addAttributes() {
        return {
            key: { default: '', parseHTML: element => element.getAttribute('data-contract-field'), renderHTML: attributes => ({ 'data-contract-field': attributes.key }) },
            label: { default: '', parseHTML: element => element.getAttribute('data-contract-label'), renderHTML: attributes => ({ 'data-contract-label': attributes.label }) },
        };
    },
    parseHTML() { return [{ tag: 'span[data-contract-field]' }]; },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes, { class: 'contract-field-token', contenteditable: 'false' }), `[${HTMLAttributes['data-contract-label'] || HTMLAttributes['data-contract-field']}]`];
    },
});

export const ContractSignatureNode = Node.create({
    name: 'contractSignature',
    group: 'block',
    atom: true,
    selectable: true,
    addAttributes() {
        return { role: { default: 'client', parseHTML: element => element.getAttribute('data-contract-signature'), renderHTML: attributes => ({ 'data-contract-signature': attributes.role }) } };
    },
    parseHTML() { return [{ tag: 'div[data-contract-signature]' }]; },
    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes, { class: 'contract-signature-token', contenteditable: 'false' }), `${HTMLAttributes['data-contract-signature'] === 'tenant' ? 'Tenant' : 'Client'} signature`];
    },
});

export const ContractTableNode = Node.create({
    name: 'contractTable',
    group: 'block',
    atom: true,
    selectable: true,
    addAttributes() {
        return {
            key: { default: '', parseHTML: element => element.getAttribute('data-contract-table'), renderHTML: attributes => ({ 'data-contract-table': attributes.key }) },
            label: { default: '', parseHTML: element => element.getAttribute('data-contract-table-label'), renderHTML: attributes => ({ 'data-contract-table-label': attributes.label }) },
        };
    },
    parseHTML() { return [{ tag: 'div[data-contract-table]' }]; },
    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes, { class: 'contract-table-token', contenteditable: 'false' }), `Dynamic table: ${HTMLAttributes['data-contract-table-label'] || HTMLAttributes['data-contract-table']}`];
    },
});
